import ApiService from '../api.services';

const ShippingIntegrationService = {
  list: async function () {
    try {
      const response = await ApiService.get(`/gateway/shipping/integration`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  filter: async function (type) {
    try {
      const response = await ApiService.get(`/gateway/shipping/integration?type=${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async function (data) {
    try {
      const response = await ApiService.post(`/gateway/shipping/integration`, data);
      return response.data;
    } catch (error) {
      console.log('throw', error)
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/gateway/shipping/integration/${id}`);
      return response.data;
    } catch (error) {
      console.log('throw', error)
      throw error;
    }
  },
};

export default ShippingIntegrationService;

export { ShippingIntegrationService };

